import { ChartData, ChartDataset, ChartType } from "chart.js"
import env from "../env"

export const transformIndicatorData = (
    indicatorData: Indicators.IndicatorData,
    showLabels: boolean,
): Indicators.Indicator => ({
    chartData: transformChartData(indicatorData.ChartData),
    color: indicatorData.ColorIndication,
    description: indicatorData.Description,
    hasChart: indicatorData.GraphType !== "Single value",
    id: indicatorData.IndicatorId,
    showLabels,
    title: indicatorData.Name,
    url: `${env.applicationPath}/${indicatorData.DetailsUrl}`,
    value: indicatorData.ActualValue,
})

export const transformChartData = (
    chartData: Indicators.INCAChartData,
): ChartData => {
    const datasetActuals = transformChartDataSet(
        chartData.DataSets[0].Colors,
        "#30ff00",
        chartData.DataSets[0].Values,
        "",
        3,
        chartData.DataSets[0].GraphType,
    )

    const data: ChartData = {
        labels: chartData.XLabels,
        datasets: [],
    }

    // add target line if there is at least one target value filled
    if (chartData.DataSets[1].Values.some((value) => value > 0)) {
        data.datasets?.push(
            transformChartDataSet(
                ["#5ff2ff"],
                "#5ff2ff",
                chartData.DataSets[1].Values,
                chartData.DataSets[1].Label,
                1,
                chartData.DataSets[1].GraphType,
            ),
        )
    }

    data.datasets?.push(datasetActuals)

    // add a threshold line if there is one
    if (chartData.DataSets.length === 3) {
        data.datasets?.push(
            transformChartDataSet(
                ["#343434"],
                "#343434",
                chartData.DataSets[2].Values,
                chartData.DataSets[2].Label,
                2,
                chartData.DataSets[2].GraphType,
            ),
        )
    }
    return data
}

export const transformChartDataSet = (
    backgroundColor: string[],
    borderColor: string,
    data: number[],
    label: string,
    order: number,
    type: ChartType,
): ChartDataset => {
    const dataset: ChartDataset = {
        backgroundColor,
        barPercentage: 1.02,
        borderColor,
        categoryPercentage: 1,
        data,
        fill: false,
        label,
        pointRadius: 0,
        order,
        type,
    }

    if (type === "line") {
        dataset.borderWidth = 3
    }

    return dataset
}
